import Const from 'constants';

let Router = {
    redirectTo(url) {
        return {
            type: Const.ROUTING,
            payload: {
                method: 'replace',
                nextUrl: url,
            },
        };
    },
};

export default Router;
